import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IMAGE_SRC } from '../../shared/shared-constants';
import { DONE } from './sublink-icon.constants';
import { currentLocale } from 'src/app/locale.config';

@Component({
  selector: 'app-sublink-icon',
  templateUrl: './sublink-icon.component.html',
  styleUrls: ['./sublink-icon.component.scss'],
  standalone: false,
})
export class SublinkIconComponent {
  @Input({ required: true }) route!: string;
  @Input({ required: true }) displayText!: string;

  readonly DONE = DONE;
  readonly IMAGES = IMAGE_SRC;

  constructor(private router: Router) {}

  get isActive() {
    return this.router.url.includes(this.route);
  }

  get link() {
    return `${currentLocale()}/${this.route}`;
  }
}
